'use client';

import { atomWithStorage } from '@capsicum/common';
import { useAtom } from 'jotai';
import { useCallback } from 'react';

export const auctionDetailsTutorialAtom = atomWithStorage<boolean>('seenAuctionDetailsTutorial', false);

export const useSeenAuctionDetailsTutorial = () => {
	const [seenTutorial, setSeenTutorialAtomState] = useAtom(auctionDetailsTutorialAtom);

	const setSeenTutorial = useCallback(() => {
		setSeenTutorialAtomState(true);
	}, [setSeenTutorialAtomState]);

	return {
		seenTutorial,
		setSeenTutorial
	};
};
